import { useEffect, useState } from "preact/hooks";

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const list = window.matchMedia(query);
    const onChange = () => setMatches(list.matches);
    onChange();
    list.addEventListener("change", onChange);
    return () => list.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}

/** Au-delà, barre d'outils en haut et lecture + chat côte à côte ; en dessous, interface mobile. */
export const WIDE_QUERY = "(min-width: 960px)";

/**
 * Seuil de l'extrait intégré : pas de chat à côté de la lecture, et la fenêtre du site
 * (marges du modal comprises) est plus étroite que l'écran, donc la barre du haut tient plus tôt.
 */
export const EMBED_WIDE_QUERY = "(min-width: 720px)";
